import { useAuth0 } from '@auth0/auth0-react';
import { Button, Stack, Typography, styled } from '@mui/material';
import { ElementType } from 'react';
import { QuoidenLogo } from '~/assets/logos';
import { theme } from '~/shared/styles/theme';

/**
 * SponsorLoginPage component for sponsor testers to authenticate via Auth0.
 * Only provides login functionality — no account creation option.
 * The redirect_uri is automatically set by Auth0Provider to ${window.location.origin}/auth-callback.
 */
const SponsorLoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Container component="main">
      <Stack alignItems="flex-end" pt={8} pr={12}>
        <SignInButton
          onClick={() =>
            loginWithRedirect({ authorizationParams: { screen_hint: 'login' } })
          }
        >
          Sign In
        </SignInButton>
      </Stack>
      <LogoContainer>
        <QuoidenLogo />
        <CopyContainer>
          <Copy>
            Access aggregated cohort search results to evaluate patient
            availability for your studies.
          </Copy>
        </CopyContainer>
      </LogoContainer>
    </Container>
  );
};

export default SponsorLoginPage;

const Container = styled(Stack)<{ component?: ElementType }>({
  flexDirection: 'column',
  height: '100vh',
  backgroundColor: theme.palette.custom.cream,
});

const LogoContainer = styled(Stack)({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const CopyContainer = styled(Stack)({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(6),
});

const Copy = styled(Typography)({
  textAlign: 'center',
  color: theme.palette.custom.mediumBrown,
  fontWeight: 500,
  maxWidth: 300,
});

const SignInButton = styled(Button)({
  fontSize: '18px',
  width: '144px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.custom.green,
  color: theme.palette.common.white,
  borderRadius: theme.tokens.borderRadius.full,
});
